export default [ { ID:"46",
    FULL_NAME:"Armenian Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Armenia",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"",
    AGREEMENT_DATE:"June 2014",
    WEB_URL:"" },
  { ID:"48",
    FULL_NAME:"Czech Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Czech Republic",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"",
    AGREEMENT_DATE:"31 March 2015",
    WEB_URL:"http://www.jcmf.cz/?q=cz" },
  { ID:"2",
    FULL_NAME:"South African Institute of Physics",
    ABBR_NAME:"",
    CONTINENT:"Africa",
    COUNTRY:"South Africa",
    ADDRESS_LINE_1:"Postnet Suite 165",
    ADDRESS_LINE_2:"Private Bag X025",
    ADDRESS_LINE_3:"Lynnwood Ridge",
    ADDRESS_LINE_4:"0040",
    ADDRESS_LINE_5:"South Africa",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Lynnwood Ridge",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"0040",
    CONTACT_EMAIL:"secretary@saip.org.za",
    PRESIDENT:"Dr. Simon Connell",
    AGREEMENT_DATE:"1 October 1998",
    WEB_URL:"http://www.saip.org.za/" },
  { ID:"3",
    FULL_NAME:"Société Tunisienne de Physique",
    ABBR_NAME:"",
    CONTINENT:"Africa",
    COUNTRY:"Tunisia",
    ADDRESS_LINE_1:"Department of Physics",
    ADDRESS_LINE_2:"Faculty of Sciences of Tunis",
    ADDRESS_LINE_3:"University of Tunis El Manar 2092",
    ADDRESS_LINE_4:"Tunis, Tunisia",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"stp@stp.org.tn",
    PRESIDENT:"Professor Raouf Bennaceur",
    AGREEMENT_DATE:"January 2008",
    WEB_URL:"" },
  { ID:"5",
    FULL_NAME:"Chinese Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"China, Beijing",
    ADDRESS_LINE_1:"Institute of Physics",
    ADDRESS_LINE_2:"Chinese Academy of Sciences",
    ADDRESS_LINE_3:"P.O. Box 603",
    ADDRESS_LINE_4:"Beijing 100190",
    ADDRESS_LINE_5:"P.R. China",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Beijing",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"100190",
    CONTACT_EMAIL:"cps@aphy.iphy.ac.cn",
    PRESIDENT:"Professor Zhan Wen-long",
    AGREEMENT_DATE:"",
    WEB_URL:"http://www.cps-net.org.cn/" },
  { ID:"6",
    FULL_NAME:"The Physical Society of Taiwan",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"China, Taipei",
    ADDRESS_LINE_1:"PO Box 30",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"Taipei",
    PROVINCE:"Taiwan",
    STATE_CODE:"",
    POSTAL_CODE:"106",
    CONTACT_EMAIL:"office@ps-taiwan.org",
    PRESIDENT:"Professor Yee Bob Hsiung",
    AGREEMENT_DATE:"7 March 1992",
    WEB_URL:"https://www.ps-taiwan.org" },
  { ID:"7",
    FULL_NAME:"Physical Society of Hong Kong",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Hong Kong",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"soapy@ust.hk",
    PRESIDENT:"Professor Hai Qing Lin",
    AGREEMENT_DATE:"5 May 1997",
    WEB_URL:"http://www.pshk.org.hk/" },
  { ID:"11",
    FULL_NAME:"The Korean Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Korea, The Republic of",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Seoul",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"135-703",
    CONTACT_EMAIL:"office@mulli.kps.or.kr",
    PRESIDENT:"Dr. Sung-Chul Shin",
    AGREEMENT_DATE:"26 February 1993",
    WEB_URL:"https://www.kps.or.kr/eng/about/about.php" },
  { ID:"14",
    FULL_NAME:"New Zealand Institute of Physics",
    ABBR_NAME:"NZIP",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"New Zealand",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"president@nzip.org.nz",
    PRESIDENT:"Dr. Peter Derrick",
    AGREEMENT_DATE:"9 September 2000",
    WEB_URL:"http://www.nzip.org.nz/" },
  { ID:"15",
    FULL_NAME:"Institute of Physics Singapore",
    ABBR_NAME:"IPS",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Singapore",
    ADDRESS_LINE_1:"c/o Department of Physics",
    ADDRESS_LINE_2:"National University of Singapore",
    ADDRESS_LINE_3:"2 Science Drive 3",
    ADDRESS_LINE_4:"Singapore 117542",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"ips@physics.nus.edu.sg",
    PRESIDENT:"Professor Kwek Leong Chuan",
    AGREEMENT_DATE:"6 March 2006",
    WEB_URL:"http://www.physics.nus.edu.sg/~phyips/index.html" },
  { ID:"18",
    FULL_NAME:"European Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"France",
    ADDRESS_LINE_1:"6 rue des Frères Lumière",
    ADDRESS_LINE_2:"F-68200 Mulhouse Cedex",
    ADDRESS_LINE_3:"France",
    ADDRESS_LINE_4:"(EPS-Reciprocal with *individual* members)",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Professor Luisa Cifarelli",
    AGREEMENT_DATE:"",
    WEB_URL:"http://www.eps.org/" },
  { ID:"19",
    FULL_NAME:"The Belarusian Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Belarus",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"dvnovitsky@gmail.com",
    PRESIDENT:"",
    AGREEMENT_DATE:"4 April 2000",
    WEB_URL:"http://master.basnet.by/bfo/" },
  { ID:"21",
    FULL_NAME:"Estonian Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Estonia",
    ADDRESS_LINE_1:"Ravila 14C",
    ADDRESS_LINE_2:"50411 Tartu",
    ADDRESS_LINE_3:"Estonia",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"efs@fyysika.ee",
    PRESIDENT:"Professor Kaido Reivelt",
    AGREEMENT_DATE:"19 September 1995",
    WEB_URL:"http://www.fyysika.ee/efs/" },
  { ID:"22",
    FULL_NAME:"Deutsche Physikalische Gesellschaft",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Germany",
    ADDRESS_LINE_1:"Hauptstraße 5",
    ADDRESS_LINE_2:"D-53604 Bad Honnef",
    ADDRESS_LINE_3:"Germany",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"dpg@dpg-physik.de",
    PRESIDENT:"Prof. Johanna Stachel",
    AGREEMENT_DATE:"1 December 1992",
    WEB_URL:"http://www.dpg-physik.de/index.html" },
  { ID:"23",
    FULL_NAME:"Roland Eötvös Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Hungary",
    ADDRESS_LINE_1:"Ráday utca 18. Fsz./3",
    ADDRESS_LINE_2:"H-1092 Budapest",
    ADDRESS_LINE_3:"Hungary",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"elft@elft.hu",
    PRESIDENT:"Dr. Norbert Kroó",
    AGREEMENT_DATE:"6 May 1996",
    WEB_URL:"http://www.kfki.hu/elft/" },
  { ID:"24",
    FULL_NAME:"Icelandic Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Iceland",
    ADDRESS_LINE_1:"Dunhaga 3",
    ADDRESS_LINE_2:"IS-107 Reykjavik",
    ADDRESS_LINE_3:"Iceland",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Professor Sveinn Olafsson",
    AGREEMENT_DATE:"October 1997",
    WEB_URL:"" },
  { ID:"25",
    FULL_NAME:"Lithuanian Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Lithuania",
    ADDRESS_LINE_1:"Institute of Theoretical Physics and Astronomy",
    ADDRESS_LINE_2:"A.Goštauto 12",
    ADDRESS_LINE_3:"2600 Vilnius",
    ADDRESS_LINE_4:"Lithuania",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"lfd@itpa.lt",
    PRESIDENT:"Dr. Juozas Vaitkus",
    AGREEMENT_DATE:"4 April 2002",
    WEB_URL:"" },
  { ID:"26",
    FULL_NAME:"The Polish Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Poland",
    ADDRESS_LINE_1:"Main Board",
    ADDRESS_LINE_2:"69 Hoza St.",
    ADDRESS_LINE_3:"PL-00681 Warsaw",
    ADDRESS_LINE_4:"Poland",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Warsaw",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"ptf@fuw.edu.pl",
    PRESIDENT:"Professor Wieslaw Kaminski",
    AGREEMENT_DATE:"22 May 1992",
    WEB_URL:"" },
  { ID:"27",
    FULL_NAME:"Slovak Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Slovak Republic",
    ADDRESS_LINE_1:"Dubravska cesta 9",
    ADDRESS_LINE_2:"SK-845 27 Bratislava 45",
    ADDRESS_LINE_3:"Slovak Republic",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"sfs@savba.sk",
    PRESIDENT:"Dr. Marian Reiffers",
    AGREEMENT_DATE:"22 September 1995",
    WEB_URL:"http://sfs.sav.sk/" },
  { ID:"28",
    FULL_NAME:"Real Sociedad Española de Física",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Spain",
    ADDRESS_LINE_1:"Facultad de Ciencias Físicas",
    ADDRESS_LINE_2:"Universidad Complutense",
    ADDRESS_LINE_3:"28040 Madrid",
    ADDRESS_LINE_4:"Spain",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Madrid",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"secret.y.admon@rsef.es",
    PRESIDENT:"Professor María Rosario Heras Celemín",
    AGREEMENT_DATE:"12 July 1999",
    WEB_URL:"http://www.ucm.es/info/rsef/" },
  { ID:"29",
    FULL_NAME:"Swedish Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Sweden",
    ADDRESS_LINE_1:"Department of Physics and Astronomy",
    ADDRESS_LINE_2:"Uppsala University",
    ADDRESS_LINE_3:"Box 516",
    ADDRESS_LINE_4:"751 20 Uppsala",
    ADDRESS_LINE_5:"Sweden",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Professor Karl-Fredrik Berggren",
    AGREEMENT_DATE:"12 August 2003",
    WEB_URL:"http://www.fysikersamfundet.se/english.html" },
  { ID:"30",
    FULL_NAME:"Swiss Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Switzerland",
    ADDRESS_LINE_1:"Klingelbergstrasse 82",
    ADDRESS_LINE_2:"4056 Basel",
    ADDRESS_LINE_3:"Switzerland",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"sps@unibas.ch",
    PRESIDENT:"Dr. Andreas Schopper",
    AGREEMENT_DATE:"26 August 2001",
    WEB_URL:"http://www.sps.ch/" },
  { ID:"33",
    FULL_NAME:"The Israel Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Middle East",
    COUNTRY:"Israel",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"hadar.alper@weizmann.ac.il",
    PRESIDENT:"Prof. Yigal Meir",
    AGREEMENT_DATE:"28 October 1996",
    WEB_URL:"http://www.israelphysicalsociety.org/" },
  { ID:"34",
    FULL_NAME:"Pakistan Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Middle East",
    COUNTRY:"Pakistan",
    ADDRESS_LINE_1:"Room No 205",
    ADDRESS_LINE_2:"Technical Block",
    ADDRESS_LINE_3:"NCP",
    ADDRESS_LINE_4:"Islamabad",
    ADDRESS_LINE_5:"Pakistan",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Prof. Dr. Hassan A. Shah",
    AGREEMENT_DATE:"9 August 2001",
    WEB_URL:"http://pps-pak.org/" },
  { ID:"35",
    FULL_NAME:"Turkish Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Middle East",
    COUNTRY:"Turkey",
    ADDRESS_LINE_1:"c/o Professor Baki Akkus",
    ADDRESS_LINE_2:"Istanbul University, Faculty of Science",
    ADDRESS_LINE_3:"Department of Physics",
    ADDRESS_LINE_4:"34134",
    ADDRESS_LINE_5:"Vezneciler-Istanbul",
    ADDRESS_LINE_6:"Turkey",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Professor Baki Akkus",
    AGREEMENT_DATE:"15 June 2008",
    WEB_URL:"http://tfd.com.tr/" },
  { ID:"36",
    FULL_NAME:"Canadian Association of Physicists",
    ABBR_NAME:"CAP",
    CONTINENT:"North America",
    COUNTRY:"Canada",
    ADDRESS_LINE_1:"555 King Edward Avenue",
    ADDRESS_LINE_2:"3rd Floor",
    ADDRESS_LINE_3:"Ottawa, Ontario, Canada K1N 7N5",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"Ottawa",
    PROVINCE:"Ontario",
    STATE_CODE:"",
    POSTAL_CODE:"K1N 7N5",
    CONTACT_EMAIL:"cap@physics.uottawa.ca",
    PRESIDENT:"Professor Gabor Kunstatter",
    AGREEMENT_DATE:"",
    WEB_URL:"http://www.cap.ca/" },
  { ID:"38",
    FULL_NAME:"Asociación Física Argentina",
    ABBR_NAME:"",
    CONTINENT:"South America",
    COUNTRY:"Argentina",
    ADDRESS_LINE_1:"C.C. 67 (1900) La Plata",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"secretaria@fisica.org.ar",
    PRESIDENT:"Dr. Francisco Tamarit",
    AGREEMENT_DATE:"28 September 1994",
    WEB_URL:"http://www.fisica.org.ar/" },
  { ID:"40",
    FULL_NAME:"Sociedad Chilena de Física",
    ABBR_NAME:"SOCHIFI",
    CONTINENT:"South America",
    COUNTRY:"Chile",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Professor Juan Carlos Retamal",
    AGREEMENT_DATE:"25 July 2003",
    WEB_URL:"" },
  { ID:"41",
    FULL_NAME:"Sociedad Colombiana de Física",
    ABBR_NAME:"",
    CONTINENT:"South America",
    COUNTRY:"Colombia",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Dr. José Herman Muñoz",
    AGREEMENT_DATE:"28 September 1994",
    WEB_URL:"" },
  { ID:"42",
    FULL_NAME:"Sociedad Uruguaya de Física",
    ABBR_NAME:"",
    CONTINENT:"South America",
    COUNTRY:"Uruguay",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"suf@fisica.edu.uy",
    PRESIDENT:"Dr. Erna Frins",
    AGREEMENT_DATE:"20 March 1999",
    WEB_URL:"http://suf.fisica.edu.uy/" },
  { ID:"43",
    FULL_NAME:"Sociedad Venezolana de Física",
    ABBR_NAME:"",
    CONTINENT:"South America",
    COUNTRY:"Venezuela",
    ADDRESS_LINE_1:"Departamento de Física",
    ADDRESS_LINE_2:"Universidad Simon Bolivar",
    ADDRESS_LINE_3:"Apartado Postal 89000",
    ADDRESS_LINE_4:"Caracas 1080-A",
    ADDRESS_LINE_5:"Venezuela",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"svf@fisica.ciens.ucv.ve",
    PRESIDENT:"Dr. Williams Barreto",
    AGREEMENT_DATE:"28 September 1994",
    WEB_URL:"http://fisica.ciens.ucv.ve/svf/" },
  { ID:"51",
    FULL_NAME:"Sociedad Dominicana de Física",
    ABBR_NAME:"",
    CONTINENT:"Caribbean",
    COUNTRY:"Dominican Republic",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"N",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"",
    AGREEMENT_DATE:"7 November 2018",
    WEB_URL:"https://www.sodofi.org/" },
  { ID:"4",
    FULL_NAME:"Australian Institute of Physics",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Australia",
    ADDRESS_LINE_1:"Secretariat",
    ADDRESS_LINE_2:"PO Box 546",
    ADDRESS_LINE_3:"East Melbourne, Vic. 3002",
    ADDRESS_LINE_4:"Australia",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"aip@aip.org.au",
    PRESIDENT:"Dr. Rob Robinson",
    AGREEMENT_DATE:"3 July 1992",
    WEB_URL:"http://aip.org.au/" },
  { ID:"8",
    FULL_NAME:"Indian Physics Association",
    ABBR_NAME:"IPA",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"India",
    ADDRESS_LINE_1:"PRIP Shed, Room No. 4",
    ADDRESS_LINE_2:"Bhabha Atomic Research Centre",
    ADDRESS_LINE_3:"Trombay",
    ADDRESS_LINE_4:"Mumbai-400085",
    ADDRESS_LINE_5:"India",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Trombay",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"ipa.india@gmail.com",
    PRESIDENT:"Professor Milan K. Sanyal",
    AGREEMENT_DATE:"5 April 1997",
    WEB_URL:"http://www.ipa1970.org.in/" },
  { ID:"9",
    FULL_NAME:"The Physical Society of Japan",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Japan",
    ADDRESS_LINE_1:"Yushima Urban Building 8F",
    ADDRESS_LINE_2:"2-31-22 Yushima, Bunkyo-ku",
    ADDRESS_LINE_3:"Tokyo 113-0034",
    ADDRESS_LINE_4:"Japan",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Tokyo",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"105-0004",
    CONTACT_EMAIL:"",
    PRESIDENT:"Dr. Hiroyuki Shiba",
    AGREEMENT_DATE:"",
    WEB_URL:"http://www.jps.or.jp/" },
  { ID:"10",
    FULL_NAME:"The Japan Society of Applied Physics",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Japan",
    ADDRESS_LINE_1:"Yushima Urban Building 7F",
    ADDRESS_LINE_2:"2-31-22 Yushima, Bunkyo-ku",
    ADDRESS_LINE_3:"Tokyo 113-0034",
    ADDRESS_LINE_4:"Japan",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"Tokyo",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"113-0034",
    CONTACT_EMAIL:"general-matters@jsap.or.jp",
    PRESIDENT:"Dr. Makoto Konagai",
    AGREEMENT_DATE:"",
    WEB_URL:"http://www.jsap.or.jp/" },
  { ID:"12",
    FULL_NAME:"Mongolian Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Mongolia",
    ADDRESS_LINE_1:"1st building of National University of Mongolia",
    ADDRESS_LINE_2:"Room No 1-307",
    ADDRESS_LINE_3:"Street of University building No 1",
    ADDRESS_LINE_4:"District Sukhbaatar",
    ADDRESS_LINE_5:"Ulaanbaatar, Mongolia",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"gantsog@num.edu.mn",
    PRESIDENT:"Prof. Dr. Ts Gantsog",
    AGREEMENT_DATE:"18 November 2003",
    WEB_URL:"" },
  { ID:"13",
    FULL_NAME:"Nepal Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Nepal",
    ADDRESS_LINE_1:"Tri-Chandra Campus, Ghantaghar",
    ADDRESS_LINE_2:"P.O. BOX -2934",
    ADDRESS_LINE_3:"Kathmandu",
    ADDRESS_LINE_4:"Nepal",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"nps_nepal@yahoo.com",
    PRESIDENT:"Prof. Shekhar Gurung",
    AGREEMENT_DATE:"21 September 1995",
    WEB_URL:"http://www.nps.org.np/" },
  { ID:"16",
    FULL_NAME:"Vietnam Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Vietnam",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"vps@iop.vast.ac.vn",
    PRESIDENT:"Dr. Phan Hong Khoi",
    AGREEMENT_DATE:"27 May 1994",
    WEB_URL:"https://vpshvl.org.vn/en/about/VIETNAM-PHYSICAL-SOCIETY-VPS.html" },
  { ID:"17",
    FULL_NAME:"Sociedad Cubana de Física",
    ABBR_NAME:"",
    CONTINENT:"Caribbean",
    COUNTRY:"Cuba",
    ADDRESS_LINE_1:"Physics Faculty",
    ADDRESS_LINE_2:"University of Havana",
    ADDRESS_LINE_3:"Colina Universitaria 10400",
    ADDRESS_LINE_4:"La Habana, Cuba",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Dr. Augusto González",
    AGREEMENT_DATE:"2 May 2000",
    WEB_URL:"https://fisica.uh.cu/scf/" },
  { ID:"20",
    FULL_NAME:"Belgian Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Belgium",
    ADDRESS_LINE_1:"c/o Dr. Jean-Claude Jodogne, BPS Secretary",
    ADDRESS_LINE_2:"Royal Meteorological Institute of Belgium",
    ADDRESS_LINE_3:"3, avenue Circulaire",
    ADDRESS_LINE_4:"B-1180 UCCLE",
    ADDRESS_LINE_5:"Belgium",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"BPSsecretary@oma.be",
    PRESIDENT:"Dr. Luc Henrard",
    AGREEMENT_DATE:"15 November 2002",
    WEB_URL:"https://www.belgianphysicalsociety.be/" },
  { ID:"31",
    FULL_NAME:"Ukrainian Physical Society",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"Ukraine",
    ADDRESS_LINE_1:"Prospekt Glushkova 4, Room 201",
    ADDRESS_LINE_2:"Kyiv 03680",
    ADDRESS_LINE_3:"Ukraine",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"ukr_phys_soc@ukr.net",
    PRESIDENT:"",
    AGREEMENT_DATE:"19 May 1992",
    WEB_URL:"http://www.ups.kiev.ua/index_e.php" },
  { ID:"32",
    FULL_NAME:"The Institute of Physics",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"United Kingdom",
    ADDRESS_LINE_1:"37 Caledonian Road",
    ADDRESS_LINE_2:"London N1 9BU",
    ADDRESS_LINE_3:"United Kingdom",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"physics@iop.org",
    PRESIDENT:"Sir Peter Knight",
    AGREEMENT_DATE:"2 March 1992",
    WEB_URL:"http://www.iop.org/" },
  { ID:"37",
    FULL_NAME:"Sociedad Mexicana de Física, A.C.",
    ABBR_NAME:"",
    CONTINENT:"North America",
    COUNTRY:"Mexico",
    ADDRESS_LINE_1:"Departamento de Física, 2do. Piso",
    ADDRESS_LINE_2:"Facultad de Ciencias, UNAM",
    ADDRESS_LINE_3:"Ciudad Universitaria, Delegatión Coyoacán",
    ADDRESS_LINE_4:"C.P. 04510 México D.F.",
    ADDRESS_LINE_5:"México",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"smf@hp.fciencias.unam.mx",
    PRESIDENT:"Dr. Jaime Urrutia Fucugauchi",
    AGREEMENT_DATE:"",
    WEB_URL:"http://www.smf.mx/" },
  { ID:"39",
    FULL_NAME:"Sociedade Brasileira de Física",
    ABBR_NAME:"",
    CONTINENT:"South America",
    COUNTRY:"Brazil",
    ADDRESS_LINE_1:"Secretaria Geral",
    ADDRESS_LINE_2:"Rua do Matão, travessa R, 187",
    ADDRESS_LINE_3:"Cidade Universitária",
    ADDRESS_LINE_4:"CEP 05508-090, São Paulo, SP",
    ADDRESS_LINE_5:"Brasil",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Dr. Celso Pinto de Melo",
    AGREEMENT_DATE:"30 September 1993",
    WEB_URL:"http://www.sbfisica.org.br/" },
  { ID:"44",
    FULL_NAME:"Federación Iberoamericana de Sociedades de Física",
    ABBR_NAME:"FEIASOFI",
    CONTINENT:"South America",
    COUNTRY:"Latin America",
    ADDRESS_LINE_1:"",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"Dr. Luis Fernando Castro Ramírez",
    AGREEMENT_DATE:"28 September 1994",
    WEB_URL:"http://www.feiasofi.net/" },
  { ID:"45",
    FULL_NAME:"Société Française de Physique",
    ABBR_NAME:"",
    CONTINENT:"Europe",
    COUNTRY:"France",
    ADDRESS_LINE_1:"33, rue Croulebarbe",
    ADDRESS_LINE_2:"75013 Paris",
    ADDRESS_LINE_3:"France",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"",
    AGREEMENT_DATE:"14 April 2014",
    WEB_URL:"http://www.sfpnet.fr/" },
  { ID:"47",
    FULL_NAME:"Union of Physicists in Bulgaria",
    ABBR_NAME:"UPB",
    CONTINENT:"Europe",
    COUNTRY:"Bulgaria",
    ADDRESS_LINE_1:"Sofia, Bulgaria",
    ADDRESS_LINE_2:"",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"",
    AGREEMENT_DATE:"22 January 2015",
    WEB_URL:"http://www.phys.uni-sofia.bg/upb/" },
  { ID:"49",
    FULL_NAME:"Institute of Physics Sri Lanka",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Sri Lanka",
    ADDRESS_LINE_1:"Vidya Mandiraya",
    ADDRESS_LINE_2:"120/10, Wijerama Mawatha",
    ADDRESS_LINE_3:"Colombo 7",
    ADDRESS_LINE_4:"Sri Lanka",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"",
    AGREEMENT_DATE:"20 January 2016​",
    WEB_URL:"http://www.ipsl.lk/" },
  { ID:"50",
    FULL_NAME:"Association of Asia Pacific Physical Societies",
    ABBR_NAME:"",
    CONTINENT:"Asia and the Pacific",
    COUNTRY:"Asia",
    ADDRESS_LINE_1:"Asia Pacific Center for Theoretical Physics (Headquarters of the AAPPS)",
    ADDRESS_LINE_2:"Hogil Kim Memorial Building #501 POSTECH",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"67 Cheongam-ro, Nam-gu, Pohang-si, Gyeongsangbuk-do",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"",
    PRESIDENT:"",
    AGREEMENT_DATE:"5 December 2017",
    WEB_URL:"http://www.aapps.org/main/" },
  { ID:"52",
    FULL_NAME:"Società Italiana di Fisica",
    ABBR_NAME:"SIF",
    CONTINENT:"Europe",
    COUNTRY:"Italy",
    ADDRESS_LINE_1:"Via Saragozza 12",
    ADDRESS_LINE_2:"Bologna, Italy",
    ADDRESS_LINE_3:"",
    ADDRESS_LINE_4:"",
    ADDRESS_LINE_5:"",
    ADDRESS_LINE_6:"",
    ADDR_OVERWRITE:"Y",
    CITY:"",
    PROVINCE:"",
    STATE_CODE:"",
    POSTAL_CODE:"",
    CONTACT_EMAIL:"sif@sif.it",
    PRESIDENT:"",
    AGREEMENT_DATE:"8 May 2019",
    WEB_URL:"https://www.sif.it/" } ];